import { TranslationFile } from 'i18n'
import { useTranslation } from 'react-i18next'

import appConfig from 'app.config'
import { IApplicationInformation } from 'interfaces/i-application-information'
import { FinancialSituationTypes } from 'constants/enums/financialSituationTypes'

export const FinancialSituationFormUK = (data: IApplicationInformation) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Countries,
	])

	return {
		fieldSetName: '',
		formName: 'FinancialSituationForm',
		collapsable: false,
		description: t('Financial situation'),
		show: true,
		visible: true,
		market: appConfig.country,
		fullSize: true,
		col: 12,
		controls: [
			{
				required: true,
				controlName: 'financialSituation',
				type: 'radio',
				description: t('forms:FinancialSituationDescription'),
				options: [
					{
						value: FinancialSituationTypes.Improve,
						label: t('forms:YesImprove'),
					},
					{
						value: FinancialSituationTypes.Same,
						label: t('forms:NoSame'),
					},
					{
						value: FinancialSituationTypes.Worse,
						label: t('forms:YesWorse'),
					},
				],
				visible: true,
				col: 12,
			},
		],
	}
}
